import { createSlice } from '@reduxjs/toolkit';

const licencesSlice = createSlice({
  name: 'licences',
  initialState: { hasValidObjectiveLicence: false },
  reducers: {
    setObjectiveLicences: (state, { payload }) => {
      state.hasValidObjectiveLicence = payload;
    }
  }
});

export const { setObjectiveLicences } = licencesSlice.actions;
export default licencesSlice.reducer;

export const objectiveLicences = state => state.licencesSlice.hasValidObjectiveLicence;
